import React from 'react';
import { Snackbar, Alert } from '@mui/material';

function TopAlert({ open, message, severity, onClose }) {
  return (
    <Snackbar 
      open={open} 
      autoHideDuration={3000} 
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{ 
          minWidth: '200px',
          boxShadow: 2
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default TopAlert;
